// extracted by mini-css-extract-plugin
export default {"summaryMainWrapper":"summary_summaryMainWrapper__Tu3am","title":"summary_title__qfqy2","summaryWrapper":"summary_summaryWrapper__GEbKX"};